export const maxInlineImageBytes = 1024 * 1024
export const maxInlineImageEdge = 1200
export const allowedInlineImageTypes = ['image/png', 'image/jpeg', 'image/gif', 'image/webp']

export const inlineImageRejectionReason = (file: { type: string }): string | undefined => {
  if (!allowedInlineImageTypes.includes(file.type.toLowerCase())) {
    return 'Images can be PNG, JPEG, GIF or WEBP.'
  }
  return undefined
}

export const scaledDimensions = (width: number, height: number, maxEdge = maxInlineImageEdge) => {
  const longest = Math.max(width, height)
  if (longest <= maxEdge) {
    return { width, height }
  }
  const ratio = maxEdge / longest
  return { width: Math.round(width * ratio), height: Math.round(height * ratio) }
}

export const isTooLargeEncoded = (dataUrl: string): boolean => {
  const base64 = dataUrl.slice(dataUrl.indexOf(',') + 1)
  return Math.ceil(base64.length * 3 / 4) > maxInlineImageBytes
}
